import React from 'react';

// Checkbox component. Takes all the props and sets them as is.
const Checkbox = (props) => {
    return (
        <div>
            <input 
                type="checkbox" 
                {...props} />
        </div>
    );
}

export default Checkbox;